export { default as CreditCard } from '@assets/icons/buyAitech/credit-card.svg';
export { default as Coins } from '@assets/icons/buyAitech/coins.svg';
export { default as CryptoCircle } from '@assets/icons/buyAitech/crypto-circle.svg';
